import { OtherOption, SchoolOption, } from '@src/types';
const getPolicyForProgram = (policies, program) => {
    if (!program)
        return undefined;
    return policies.find(p => p.program?.id === program.id);
};
export const getSchoolPolicy = (myBenefits, program) => {
    if (!myBenefits?.schools || myBenefits.schools.length === 0)
        return undefined;
    return getPolicyForProgram(myBenefits.schools, program);
};
export const requireSchool = (myBenefits, program) => {
    const policy = getSchoolPolicy(myBenefits, program);
    if (!policy)
        return false;
    return policy.schoolOption === SchoolOption.SCHOOL;
};
export const requireProvider = (myBenefits, program) => {
    const policy = getSchoolPolicy(myBenefits, program);
    if (!policy)
        return false;
    return policy.schoolOption === SchoolOption.PROVIDER;
};
export const requireFieldsOfStudy = (myBenefits, program) => {
    const policy = getSchoolPolicy(myBenefits, program);
    if (!policy)
        return false;
    return policy.enforceFieldsOfStudy || false;
};
export const warnOnOtherSchool = (myBenefits, program) => {
    const policy = getSchoolPolicy(myBenefits, program);
    if (!policy)
        return true; // Default behavior is to allow Other and warn the user
    return (policy.otherSchool ?? OtherOption.WARN) === OtherOption.WARN;
};
export const warnOnOtherFieldOfStudy = (myBenefits, program) => {
    const policy = getSchoolPolicy(myBenefits, program);
    if (!policy)
        return true; // Default behavior is to allow Other and warn the user
    return (policy.otherFieldOfStudy ?? OtherOption.WARN) === OtherOption.WARN;
};
export const requirePickListValue = (myBenefits, program) => {
    const policy = getSchoolPolicy(myBenefits, program);
    if (!policy)
        return false;
    return policy.pickList?.enabled ?? false;
};
export const requireProgramName = (myBenefits, program) => {
    const policy = getSchoolPolicy(myBenefits, program);
    if (!policy)
        return true;
    return policy.requireProgramName ?? true;
};
